<template>
  <div class="block block-inverse block-fill-height contact-landing">
    <div class="block-xs-middle">
      <h1 class="block-title">
        <span class="text-ribbon text-ribbon-primary">
          <span>Reach out.</span>
        </span>
      </h1>

      <h3 class="lead">
        <span class="text-ribbon text-ribbon-primary">
          <span>
            By voice
            <a href="tel:202-573-7330">
              <span class="icon icon-old-mobile text-dark rotate-15"></span>
            </a>
            or e-mail
            <span class="icon icon-reply text-dark rotate-c"></span>
          </span>
        </span>
      </h3>

      <div class="row">
        <form
          class="col-md-6"
          action="https://formspree.io/mgeebgyq"
          method="POST"
        >
          <div class="form-row">
            <div class="form-group col-lg-6">
              <label for="inputName" class="sr-only">Name*</label>
              <input
                type="text"
                class="form-control"
                id="inputName"
                required
                placeholder="Name*"
                name="name"
              />
            </div>
            <div class="form-group col-lg-6">
              <label for="inputEmail" class="sr-only">E-mail*</label>
              <input
                type="email"
                class="form-control"
                id="inputEmail"
                required
                placeholder="E-mail*"
                name="_replyto"
              />
            </div>
          </div>
          <div class="form-group">
            <label for="inputMessage" class="sr-only">Message*</label>
            <textarea
              class="form-control"
              id="inputMessage"
              rows="4"
              required
              placeholder="Hey, I'm interested in getting in touch!"
              name="message"
            />
          </div>
          <button type="submit" class="btn btn-lg btn-primary float-right">
            Send!
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "contact",
  components: {},
  mounted() {
    window.$(".lead,.block-title,.form-group,.btn-primary").enter();
  }
};
</script>

<style lang="scss" scoped>
.icon:before {
  left: 10px;
}

.btn-primary {
  transition-duration: 1700ms !important;
  transform: translateY(40px);
}

.contact-landing {
  // attribution; https://www.pexels.com/photo/person-holding-smartphone-white-sitting-1310532/
  background-image: url("../assets/tiny/contact.jpg");
}

@mixin transition {
  @for $i from 1 through 3 {
    &:nth-child(#{$i}) {
      // transition: all .2s #{$i * .1}s ease-in;
      transition-duration: #{$i * 500}ms !important;
      transform: translateY(#{$i * 10}px);
    }
  }
}

.form-group {
  @include transition;
}
</style>
